// main.js

// import "lazysizes"; // For use with lazysizes_support config option

import Disclosure from "./scripts/utils/Disclosure.js";
import Dialog from "./scripts/utils/Dialog.js";

import Accordion from "./scripts/components/Accordion.js";
import Smartcrop from "./scripts/components/Smartcrop.js";
import CogCredits from "./scripts/components/CogCredits.js";
import CogBooking from "./scripts/components/CogBooking.js";
import LoadingIndicator from "./scripts/components/LoadingIndicator.js";
import SiteHeader from "./scripts/components/SiteHeader.js";
import MediaGallery from "./scripts/components/MediaGallery.js";
import GoogleMapsStatic from "./scripts/components/GoogleMapsStatic.js";
import SpektrixSession from "./scripts/components/SpektrixSession.js";
import SpektrixIframe from "./scripts/components/SpektrixIframe.js";
import SpektrixLogin from "./scripts/components/SpektrixLogin.js";
import Sticky from "./scripts/components/Sticky.js";
import BasketCount from "./scripts/components/BasketCount.js";

// @feature custom-seating-plan
// import SeatingPlan from "./scripts/components/SeatingPlan.js";

document.addEventListener("DOMContentLoaded", () => {
    new SpektrixSession();
});
